import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Row, Col, Icon, Popover,
} from 'antd';
import { RoundChart, Modal } from 'view/common';
import { Share } from 'view/screens';
import FIBER_IMG from 'assets/img/fiber.svg';
import BROADBAND_IMG from 'assets/img/broadband.svg';
import './style.scss';
import './style_dark.scss';

class ProjectItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverVisible: false,
    };
  }

  handleVisibleChange = () => this.setState(p => ({ popoverVisible: !p.popoverVisible }));

  produceProjectAction = (action) => {
    const { history, data } = this.props;
    this.setState({
      popoverVisible: false,
    });
    switch (action) {
      case 'OPEN': {
        history.push(`/project/${data.id}`);
        break;
      }
      case 'DUPLICATE': {
        break;
      }
      case 'SHARE': {
        this.shareModal.open();
        break;
      }
      case 'DELETE': {
        break;
      }
      default:
    }
  };

  render() {
    const { data, isDarkTheme } = this.props;
    const { popoverVisible } = this.state;
    const popoverContent = (
      <Fragment>
        <p onClick={() => this.produceProjectAction('OPEN')} className="option">
          Open Project
        </p>
        <p onClick={() => this.produceProjectAction('DUPLICATE')} className="option">
          Duplicate Project
        </p>
        <p onClick={() => this.produceProjectAction('SHARE')} className="option">
          Share Project
        </p>
        <p onClick={() => this.produceProjectAction('DELETE')} className="option">
          Delete Project
        </p>
      </Fragment>
    );

    return (
      <div className="project_item">
        <div className="title_container">
          <h1
            style={{ cursor: 'pointer' }}
            onClick={() => this.props.history.push(`/project/${data.id}`)}
          >{data.title}
          </h1>
          <Popover
            trigger="click"
            placement="bottom"
            content={popoverContent}
            title={null}
            visible={popoverVisible}
            onVisibleChange={this.handleVisibleChange}
          >
            <Icon type="ellipsis" theme="outlined" style={{ fontSize: '30px', cursor: 'pointer', color: isDarkTheme ? '#ffffff' : '#7f8e99' }} />
          </Popover>
        </div>
        <Row gutter={32} className="data_wrapper">
          <Col span={12} className="flex">
            <RoundChart percent={data.solution} title="Solution" color="orange" />
          </Col>
          <Col span={12} className="flex">
            <RoundChart percent={data.exception} title="Not Covered" color="blue" />
          </Col>
          <Col span={12} className="flex">
            <h1 className="addresses_count">{data.addresses}</h1>
            <p>{data.addresses === 1 ? 'Address' : 'Addresses'}</p>
          </Col>
          <Col span={12} className="flex" style={{ paddingLeft: '12%' }}>
            <div className="bro_fi">
              <Icon
                component={() => <img alt="" src={BROADBAND_IMG} style={{ width: '24px' }} />}
              />
              <p>Broadband</p>
            </div>
            <div className="bro_fi">
              <Icon
                component={() => <img alt="" src={FIBER_IMG} style={{ width: '24px' }} />}
              />
              <p>Fiber</p>
            </div>
          </Col>
        </Row>
        <Modal ref={(r) => { this.shareModal = r; }}>
          <Share />
        </Modal>
      </div>
    );
  }
}

export default withRouter(ProjectItem);



// WEBPACK FOOTER //
// ./src/view/screens/ProjectsList/ProjectItem.jsx